export const PLANS = {
  monthly: { lookup_key: "premium_monthly", price: "$4.99", cadence: "per month", badge: null },
  annual: { lookup_key: "premium_annual", price: "$49.99", cadence: "per year", badge: "Save 17% — 2 months free" },
};

export const TIER_TABLE = [
  { feature: "Decree generator", guest: "1 topic · 5 decrees", free: "Full sets of 10–15", premium: "Unlimited" },
  { feature: "Load more & complementary topics", guest: "—", free: "3× per day", premium: "Unlimited" },
  { feature: "Listen (read aloud)", guest: "—", free: "Included", premium: "Included" },
  { feature: "Decree history", guest: "—", free: "Last 25 · 30 days", premium: "Unlimited + search" },
  { feature: "Bible translations", guest: "3", free: "All 9", premium: "All 9" },
  { feature: "Verse highlighting", guest: "—", free: "1 color", premium: "Full 4-color set" },
  { feature: "Lexicon lookups", guest: "—", free: "5 per day", premium: "Unlimited" },
  { feature: "Decree Plans", guest: "—", free: "3-day · 1 active", premium: "3–40 days · multiple" },
  { feature: "Teachings", guest: "—", free: "First lesson of each course", premium: "Full course library" },
  { feature: "Newsfeed posting", guest: "—", free: "5 per month", premium: "Unlimited" },
];
